'use client'

import EventService from '@/service/event.service'
import { routes } from '@/utils/routes'
import huLocale from '@fullcalendar/core/locales/hu'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import { Container } from '@mui/material'
import { EventObjectTypeResponse } from '@repo/shared/types/event.types'
import dayjs from 'dayjs'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

const getFirstAndLastDay = (dateInfo: { start: Date; end: Date }) => {
  const startDate = dayjs(dateInfo.start).format('YYYY-MM-DD')
  const endDate = dayjs(dateInfo.end).format('YYYY-MM-DD')

  return {
    startDate,
    endDate,
  }
}

export function EventCalendarPage() {
  const [events, setEvents] = useState<
    | (Omit<EventObjectTypeResponse, 'startDate' | 'endDate'> & { start: string; end: string })[]
    | undefined
  >(undefined)
  const router = useRouter()

  return (
    <Container maxWidth="xl">
      <FullCalendar
        locale={huLocale}
        allDaySlot={false}
        initialView="timeGridWeek"
        firstDay={1}
        headerToolbar={{
          left: 'createNewEvent',
          right: 'dayGridMonth,timeGridWeek listMonth',
          center: 'prev title next',
        }}
        views={{
          listMonth: { buttonText: 'Lista nézet' },
        }}
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
        events={events}
        slotLabelFormat={{
          hour: 'numeric',
          minute: '2-digit',
        }}
        eventClick={(info) => {
          router.push(routes.adminEvent(info.event.id))
        }}
        slotMinTime={'08:00:00'}
        slotMaxTime={'18:00:00'}
        dayHeaderFormat={{ weekday: 'long', day: 'numeric' }}
        titleFormat={{ month: 'long', day: 'numeric' }}
        eventColor={'#AAAAAA'}
        eventTextColor={'#333F48'}
        weekends={true}
        height={600}
        datesSet={(dateInfo) => {
          const dates = getFirstAndLastDay(dateInfo)

          EventService.getEvents(dates)
            .then(({ data }) => {
              const activeEvents = data
                .filter((event) => event.status === 'ACTIVE')
                .map((event) => {
                  const { startDate, endDate, ...rest } = event
                  return { ...rest, start: startDate, end: endDate }
                })

              setEvents(activeEvents)
            })
            .catch((error: string) => {
              console.error('ERROR: ' + error)
            })
        }}
        customButtons={{
          createNewEvent: {
            text: 'Új esemény létrehozása',
            click: () => {
              router.push(routes.adminCreateEvent)
            },
          },
        }}
      />
    </Container>
  )
}
